var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import AppointmentWizard from '@/components/BookAppointment/AppointmentWizard.vue';
import { appointmentWizardState, bookRecurring, calendarPageData, fetchRecurringEvents, hasContact, isEditingAppointment, isNewBlockSlot, resetAppointmentWizardState, setSelectedCalendar, } from '@/components/BookAppointment/appointmentWizardState';
import { GHLLanguageKeysMapper } from '@/helper/const';
import Calendar from '@/models/calendar';
import CalendarEvent from '@/models/calendar_event';
import Contact from '@/models/contact';
import { setupVueI18n } from '@/plugin/vue-i18n';
import { ContactService } from '@/service/ContactService';
import { UIContentWrap } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import moment from 'moment-timezone';
import { onBeforeUnmount, onMounted, provide, ref, watch, watchEffect, } from 'vue';
import { fetchSlots, selectedCalendar, shouldAllowCustomTime, teamMemberOptions, } from '../components/BookAppointment/appointmentWizardState';
import '../index.css';
import { CalendarEventService } from '../service/CalendarEventService';
import AppState, { fetchInititalData, getEquipmentsInLocation, getRoomsInLocation, getTargetTimezone, resetAppState, setGlobalSlotsAndQuery, setInitialValues, } from '../states/book_appointment';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookAppointment',
    props: {
        route: Object,
        router: Object,
        showModal: Boolean,
        isEdit: { type: Boolean, default: false },
        onCancelClick: Function,
        locale: String,
        data: null,
        appointmentDetails: null,
    },
    setup(__props) {
        const props = __props;
        const isCustomTimeManuallySet = ref(true);
        const isCustomBlockedTimeManuallySet = ref(true);
        setupVueI18n(props.locale);
        // inject current route
        provide('route', props.route);
        provide('router', props.router);
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            AppState.router = props.router;
            AppState.isEdit = props.isEdit;
            setInitialValues(JSON.parse(props.data));
            console.log('JSON.parse(props.data): ', props);
            AppState.isLoading = true;
            yield fetchInititalData();
            if (!((_a = AppState.globalRooms) === null || _a === void 0 ? void 0 : _a.length)) {
                yield getRoomsInLocation();
            }
            if (!((_b = AppState.globalEquipments) === null || _b === void 0 ? void 0 : _b.length)) {
                yield getEquipmentsInLocation();
            }
            appointmentWizardState.selectedTimezone = AppState.timezone;
            const targetTimezone = getTargetTimezone();
            appointmentWizardState.selectedTimezone = targetTimezone;
            syncCalendarsInLocation({ isCommon: AppState.isCalendarEvent ? false : true }, false);
            if (calendarPageData.value.startTime) {
                isCustomTimeManuallySet.value = false;
                isCustomBlockedTimeManuallySet.value = false;
                appointmentWizardState.customStartTime = moment(moment(calendarPageData.value.startTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('YYYY-MM-DDTHH:mm:ss')).toDate();
                appointmentWizardState.blockedOffStartTime = moment(moment(calendarPageData.value.startTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('YYYY-MM-DDTHH:mm:ss')).toDate();
                appointmentWizardState.customStartTimePickerKey =
                    calendarPageData.value.startTime;
                appointmentWizardState.customEndTime = moment(moment(calendarPageData.value.endTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('YYYY-MM-DDTHH:mm:ss')).toDate();
                appointmentWizardState.blockedOffEndTime = moment(moment(calendarPageData.value.endTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('YYYY-MM-DDTHH:mm:ss')).toDate();
                appointmentWizardState.customEndTimePickerKey =
                    calendarPageData.value.endTime;
                if (calendarPageData.value.calendarProviderId) {
                    syncCalendarsInLocation({
                        specificTeamId: calendarPageData.value.calendarProviderId,
                        onlySpecificTeamCalendars: true,
                    });
                }
                else if (calendarPageData.value.isUserCalendar) {
                    if (hasContact.value) {
                        syncCalendarsInLocation({
                            onlySpecificTeamCalendars: true,
                            specificUserId: calendarPageData.value.userId,
                        });
                    }
                    appointmentWizardState.selectedUser = calendarPageData.value.userId;
                    appointmentWizardState.isUserSelected = true;
                }
                else if (calendarPageData.value.version) {
                    syncCalendarsInLocation({
                        onlySpecificVersionCalendars: true,
                        version: calendarPageData.value.version,
                    });
                }
                if (!calendarPageData.value.isUserCalendar &&
                    !calendarPageData.value.calendarProviderId) {
                    setSelectedCalendar({
                        title: calendarPageData.value.calendarId,
                        value: calendarPageData.value.calendarId,
                    });
                }
                else if (isNewBlockSlot.value) {
                    if (calendarPageData.value.calendarId) {
                        setSelectedCalendar({
                            title: calendarPageData.value.calendarId,
                            value: calendarPageData.value.calendarId,
                        });
                    }
                    else {
                        setSelectedCalendar({
                            title: '',
                            value: '',
                        });
                    }
                }
            }
            else if (isEditingAppointment.value) {
                yield configureAppointment();
            }
            AppState.isLoading = false;
            yield fetchSlots();
        }));
        onBeforeUnmount(() => {
            resetAppointmentWizardState();
            resetAppState();
            setGlobalSlotsAndQuery(null, null);
        });
        watch(() => appointmentWizardState.customStartTime, newValue => {
            if (newValue && isCustomTimeManuallySet.value) {
                const duration = selectedCalendar.value.slotDuration;
                appointmentWizardState.customEndTime = moment(newValue)
                    .add(duration !== null && duration !== void 0 ? duration : 30, 'minutes')
                    .toDate();
            }
            isCustomTimeManuallySet.value = true;
        });
        watch(() => appointmentWizardState.blockedOffStartTime, newValue => {
            if (newValue && isCustomBlockedTimeManuallySet.value) {
                appointmentWizardState.blockedOffEndTime = moment(newValue)
                    .add(30, 'minutes')
                    .toDate();
            }
            isCustomBlockedTimeManuallySet.value = true;
        });
        watch(() => teamMemberOptions.value, newValue => {
            if (AppState.calendarPageData.isUserCalendar &&
                AppState.calendarPageData.userId) {
                newValue.find(item => {
                    if (item.value === AppState.calendarPageData.userId &&
                        !selectedCalendar.value.isCollectiveBookingCalendar) {
                        appointmentWizardState.selectedTeamMember = item.value;
                        return true;
                    }
                });
            }
            if (shouldAllowCustomTime.value &&
                appointmentWizardState.selectedTeamMember === 'default' &&
                newValue.length > 0) {
                appointmentWizardState.selectedTeamMember = newValue[0].value;
            }
        });
        watchEffect(() => {
            if (appointmentWizardState.appointmentDate &&
                appointmentWizardState.selectedAppointmentSlot &&
                bookRecurring.value) {
                !appointmentWizardState.isSlotsLoading && fetchRecurringEvents();
            }
        });
        const configureAppointment = () => __awaiter(this, void 0, void 0, function* () {
            var _c, _d, _e, _f, _g, _h;
            let appointment;
            if (props.appointmentDetails) {
                appointment = props.appointmentDetails;
            }
            else {
                const targetTimezone = getTargetTimezone();
                const { data } = yield CalendarEventService.getEventDetails(AppState.appointmentToBeEdited, targetTimezone);
                appointment = new CalendarEvent(data.appointment);
            }
            AppState.source = appointment.source;
            appointmentWizardState.oldAppointment = appointment;
            if ((_c = appointment === null || appointment === void 0 ? void 0 : appointment.assignedResources) === null || _c === void 0 ? void 0 : _c.length) {
                const room = (_e = (_d = AppState.globalRooms) === null || _d === void 0 ? void 0 : _d.map(e => e)) === null || _e === void 0 ? void 0 : _e.find(e => { var _a; return (_a = appointment === null || appointment === void 0 ? void 0 : appointment.assignedResources) === null || _a === void 0 ? void 0 : _a.includes(e._id); });
                const equipment = (_g = (_f = AppState.globalEquipments) === null || _f === void 0 ? void 0 : _f.map(e => e)) === null || _g === void 0 ? void 0 : _g.find(e => { var _a; return (_a = appointment === null || appointment === void 0 ? void 0 : appointment.assignedResources) === null || _a === void 0 ? void 0 : _a.includes(e._id); });
                appointmentWizardState.selectedRoom =
                    (room === null || room === void 0 ? void 0 : room._id) || appointmentWizardState.selectedRoom;
                appointmentWizardState.selectedEquipment =
                    (equipment === null || equipment === void 0 ? void 0 : equipment._id) || appointmentWizardState.selectedEquipment;
                appointmentWizardState.assignedResources = appointment.assignedResources;
            }
            if (appointment.contactId) {
                // adding try catch for assigned data only
                try {
                    const { data: contactData } = yield ContactService.getContactDetails(appointment.contactId);
                    AppState.selectedContact = new Contact(contactData.contact);
                }
                catch (error) {
                    AppState.selectedContact = undefined;
                }
                if (appointment.calendarId) {
                    setSelectedCalendar({
                        title: appointment.calendarId,
                        value: appointment.calendarId,
                    });
                }
                else if (AppState.calendars.length > 0) {
                    setSelectedCalendar({
                        title: AppState.calendars[0].id,
                        value: AppState.calendars[0].id,
                    });
                }
            }
            else {
                setSelectedCalendar({
                    title: appointment.calendarId,
                    value: appointment.calendarId,
                });
            }
            isCustomTimeManuallySet.value = false;
            isCustomBlockedTimeManuallySet.value = false;
            appointmentWizardState.appointmentTitle = appointment.title;
            appointmentWizardState.appointmentDescription = appointment.notes;
            if (appointment.appointmentStatus) {
                appointmentWizardState.appointmentStatus = appointment.appointmentStatus;
            }
            if (appointmentWizardState.appointmentDescription) {
                appointmentWizardState.showDescriptionInput = true;
            }
            if (appointment.address) {
                appointmentWizardState.locationType = 'custom';
                appointmentWizardState.customLocation = appointment.address;
            }
            appointmentWizardState.customStartTime =
                appointmentWizardState.blockedOffStartTime = moment(moment(appointment.startTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('YYYY-MM-DDTHH:mm:ss')).toDate();
            appointmentWizardState.customEndTime =
                appointmentWizardState.blockedOffEndTime = moment(moment(appointment.endTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('YYYY-MM-DDTHH:mm:ss')).toDate();
            appointmentWizardState.appointmentDate = moment(appointment.startTime)
                .tz(appointmentWizardState.selectedTimezone)
                .format(appointmentWizardState.format);
            appointmentWizardState.selectedAppointmentSlot = moment(appointment.startTime)
                .tz(appointmentWizardState.selectedTimezone)
                .format('YYYY-MM-DDTHH:mm:ss');
            appointmentWizardState.appointmentSlots.push({
                label: moment(appointment.startTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('h:mm a'),
                value: moment(appointment.startTime)
                    .tz(appointmentWizardState.selectedTimezone)
                    .format('YYYY-MM-DDTHH:mm:ss'),
            });
            appointmentWizardState.selectedUser = appointment.assignedUserId;
            appointmentWizardState.isUserSelected = true;
            if (appointment.eventType === 'event' && appointment.calendarId) {
                appointmentWizardState.isUserSelected = false;
                appointmentWizardState.blockedSelectedCalendarId = appointment.calendarId;
            }
            appointmentWizardState.forceEnableDate = appointment.startTime;
            if (((_h = appointment === null || appointment === void 0 ? void 0 : appointment.guests) === null || _h === void 0 ? void 0 : _h.length) && appointment.isLocal) {
                const allContacts = appointment.guests.map((contactId) => {
                    return ContactService.getContactDetails(contactId)
                        .then(response => new Contact(response.data.contact))
                        .catch(_error => {
                        return new Contact({});
                    });
                });
                const contacts = yield Promise.all(allContacts);
                const guest = contacts.filter(contact => contact.id !== undefined);
                appointmentWizardState.existingGuest = Array.from(guest);
                appointmentWizardState.guestsRef = guest;
            }
            appointmentWizardState.guestCount = appointment.guestCount;
            appointmentWizardState.existingGuestCount = appointment.guestCount;
        });
        const syncCalendarsInLocation = (filterProps, fetchSlot = true) => __awaiter(this, void 0, void 0, function* () {
            var _j;
            // Reset calendar error to empty on load
            appointmentWizardState.calendarError = '';
            const currentLocationId = AppState.locationId;
            const user = AppState.loggedInUserDetail;
            const assigned_data_only = (_j = user === null || user === void 0 ? void 0 : user.permissions) === null || _j === void 0 ? void 0 : _j.assignedDataOnly;
            let isCalendarSet = false;
            let unsortedCalendars = AppState.calendars.map((calendar) => new Calendar(calendar));
            if (assigned_data_only) {
                unsortedCalendars = unsortedCalendars.filter(c => user.userCalendar[currentLocationId] === c.id ||
                    (c.teamMembers &&
                        c.teamMembers.find(x => x.selected && x.userId === (user === null || user === void 0 ? void 0 : user.id))));
            }
            unsortedCalendars = unsortedCalendars.filter(cal => cal.isActive);
            if (filterProps === null || filterProps === void 0 ? void 0 : filterProps.onlySpecificTeamCalendars) {
                if (filterProps === null || filterProps === void 0 ? void 0 : filterProps.specificTeamId) {
                    unsortedCalendars = unsortedCalendars.filter(calendar => {
                        return calendar.providerId === filterProps.specificTeamId;
                    });
                }
                if (filterProps === null || filterProps === void 0 ? void 0 : filterProps.specificUserId) {
                    unsortedCalendars = unsortedCalendars.filter(calendar => {
                        var _a;
                        return (_a = calendar.teamMembers) === null || _a === void 0 ? void 0 : _a.find(teamMember => teamMember.selected !== false &&
                            teamMember.userId === filterProps.specificUserId);
                    });
                }
            }
            if (filterProps === null || filterProps === void 0 ? void 0 : filterProps.onlySpecificVersionCalendars) {
                unsortedCalendars = unsortedCalendars.filter(calendar => {
                    return filterProps.version === 3
                        ? calendar.isV3Calendar
                        : !calendar.isV3Calendar;
                });
            }
            let sortedCalendars = unsortedCalendars.sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            sortedCalendars = sortedCalendars.sort((a, b) => {
                var _a, _b;
                if (a.providerId && !b.providerId) {
                    return -1;
                }
                else if (!a.providerId && b.providerId) {
                    return 1;
                }
                //if both are v3 sort by providerId, if providerId is same sort by name
                if (a.providerId === b.providerId) {
                    return (_a = a.name) === null || _a === void 0 ? void 0 : _a.localeCompare(b.name);
                }
                return (_b = a.providerId) === null || _b === void 0 ? void 0 : _b.localeCompare(b.providerId);
            });
            AppState.calendars = sortedCalendars;
            const unassignedCalendars = sortedCalendars.filter(calendar => {
                return !calendar.providerId;
            });
            if (filterProps.isCommon) {
                const roundRobinCalendar = sortedCalendars.find(calendar => calendar.isRoundRobinCalendar);
                const classCalendar = sortedCalendars.find(calendar => calendar.isClassBookingCalendar);
                const collectiveCalendar = sortedCalendars.find(calendar => calendar.isCollectiveBookingCalendar);
                const selectedCalendar = roundRobinCalendar || classCalendar || collectiveCalendar;
                if (selectedCalendar) {
                    setSelectedCalendar({
                        title: selectedCalendar.id,
                        value: selectedCalendar.id,
                    }, fetchSlot);
                    isCalendarSet = true;
                }
            }
            if (!isCalendarSet) {
                if (unassignedCalendars.length > 0) {
                    setSelectedCalendar({
                        title: unassignedCalendars[0].id,
                        value: unassignedCalendars[0].id,
                    }, fetchSlot);
                }
                else if (sortedCalendars.length > 0) {
                    setSelectedCalendar({
                        title: sortedCalendars[0].id,
                        value: sortedCalendars[0].id,
                    }, fetchSlot);
                }
                else {
                    appointmentWizardState.calendarError =
                        'No calendars found in the location.';
                }
            }
            if (sortedCalendars.length === 0 ||
                !sortedCalendars.find(cal => cal.id === appointmentWizardState.selectedCalendarId)) {
                setSelectedCalendar({
                    title: '',
                    value: '',
                });
            }
        });
        const onClickClose = () => {
            props.onCancelClick(appointmentWizardState.apptBooked);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), {
                locale: _unref(GHLLanguageKeysMapper)[props.locale]
            }, {
                default: _withCtx(() => [
                    _createVNode(AppointmentWizard, {
                        "show-modal": __props.showModal,
                        "on-cancel-click": onClickClose,
                        "is-edit": __props.isEdit
                    }, null, 8, ["show-modal", "is-edit"])
                ]),
                _: 1
            }, 8, ["locale"]));
        };
    }
});
